import React from "react";

const CustomRadioButton = React.forwardRef(({ ...othersProps }, ref) => {
  return <input ref={ref} type="radio" className="custom-radio-button" {...othersProps} />;
});

export default CustomRadioButton;
